// import * as firebase from "firebase";
var firebase = require("firebase/app");
// require("firebase/auth");
require("firebase/database");

const firebaseConfig = {
    apiKey: "AIzaSyBO4OiZBOx-bucCMfw-P52d9Xk1UdHdxxU",
    authDomain: "idlemobster.firebaseapp.com",
    databaseURL: "https://idlemobster.firebaseio.com",
    projectId: "idlemobster",
    storageBucket: "idlemobster.appspot.com",
    messagingSenderId: "161902708796",
    appId: "1:161902708796:web:b364ce7a68e84c18771b39",
    measurementId: "G-D1E6Y61DBH"
};

export default !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();